import { useState, useRef, useEffect } from 'react';
import './ButtonOption.css';

const ButtonOptionGroup = ({ label, options, selectedValue, onChange, position = '' }) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    const handleOptionClick = (value) => {
        onChange(value);
        setIsOpen(false); // Close dropdown after selection
    };

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    return (
        <div className="dropdown" ref={dropdownRef}>
            <button
                className="dropdown-btn"
                onClick={toggleDropdown}
            >
                {options.find(option => option.value === selectedValue)?.label || label}
            </button>

            {isOpen && (
                <ul className={`dropdown-list ${position}`}>
                    {options.map((option) => (
                        <li
                            key={option.value}
                            className={`dropdown-item ${selectedValue === option.value ? 'selected' : ''}`}
                            onClick={() => handleOptionClick(option.value)}
                        >
                            {option.label}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default ButtonOptionGroup;
